import React from 'react';
import { Link } from 'react-router-dom';

function Stars({ rating, size = '0.8rem' }) {
  return (
    <span className="stars" style={{ fontSize: size }}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} className={n <= Math.round(rating) ? 'star-filled' : 'star-empty'}>★</span>
      ))}
    </span>
  );
}

function UserLink({ username, rating, reviewCount, showStars = true, style }) {
  if (!username) return null;

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: '0.3rem', ...style }}
      onClick={(e) => e.stopPropagation()}
    >
      <Link
        to={`/profile/${username}`}
        style={{ color: 'var(--color-cyan)', fontWeight: 500, textDecoration: 'none' }}
        onClick={(e) => e.stopPropagation()}
      >
        {username}
      </Link>
      {showStars && rating > 0 && (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.15rem', fontSize: '0.78rem' }}>
          <Stars rating={rating} size="0.75rem" />
          <span style={{ color: 'var(--text-muted)' }}>
            {rating.toFixed(1)}{reviewCount != null && ` (${reviewCount})`}
          </span>
        </span>
      )}
    </span>
  );
}

export default UserLink;
